import {
  DetailType,
  HandballGoalAttribute,
} from '@collector/sportsapi-client-legacy'

import { DetailConfiguration } from '../../../../composables/useSportOptions'
import { GroupName } from '../../consts'

const isPenaltyGoalSelected = (
  attributes: readonly HandballGoalAttribute[],
): boolean => attributes.includes(HandballGoalAttribute.PenaltyGoal)

const isPenaltyGoalNotSelected = (
  attributes: readonly HandballGoalAttribute[],
): boolean => !isPenaltyGoalSelected(attributes)

const isPivotOrBreakthroughActive = (
  attributes: readonly HandballGoalAttribute[],
): boolean =>
  isPenaltyGoalNotSelected(attributes) &&
  !attributes.some((attribute) =>
    [
      HandballGoalAttribute.LeftWing,
      HandballGoalAttribute.RightWing,
      HandballGoalAttribute.NineMeter,
    ].includes(attribute),
  )

export const groups: Map<
  GroupName,
  DetailConfiguration<HandballGoalAttribute>
> = new Map([
  [
    GroupName.Style,
    {
      type: DetailType.Button,
      name: GroupName.Style,
      important: true,
      fulfilledWhen: (attributes: readonly HandballGoalAttribute[]) => {
        return (
          isPenaltyGoalSelected(attributes) ||
          attributes.some((attribute) =>
            [HandballGoalAttribute.Air, HandballGoalAttribute.Ground].includes(
              attribute,
            ),
          )
        )
      },
      attributes: [
        {
          attributeId: HandballGoalAttribute.Air,
          isActive: isPenaltyGoalNotSelected,
        },
        {
          attributeId: HandballGoalAttribute.Ground,
          isActive: isPenaltyGoalNotSelected,
        },
      ],
      cols: 2,
      multiple: false,
    },
  ],
  [
    GroupName.Type,
    {
      type: DetailType.Button,
      name: GroupName.Type,
      important: false,
      attributes: [
        {
          attributeId: HandballGoalAttribute.FastAttack,
          isActive: isPenaltyGoalNotSelected,
        },
        {
          attributeId: HandballGoalAttribute.AfterTurnover,
          isActive: isPenaltyGoalNotSelected,
        },
        {
          attributeId: HandballGoalAttribute.EmptyNetGoal,
          isActive: isPenaltyGoalNotSelected,
        },
        HandballGoalAttribute.PenaltyGoal,
        {
          attributeId: HandballGoalAttribute.Pivot,
          isActive: isPivotOrBreakthroughActive,
        },
        {
          attributeId: HandballGoalAttribute.Breakthrough,
          isActive: isPivotOrBreakthroughActive,
        },
      ],
      cols: 3,
      multiple: true,
    },
  ],
])
